<template>
    <div class="d-flex flex-column align-items-center">
        <div class="m-b-48">
            <h4 class="text-center m-0 font Roboto f-s-20 f-w-700 l-h-24" style="letter-spacing: -0.5;">
                {{ titleText }}
            </h4>
            <h2 class="text-center m-0 font Roboto f-s-32 f-w-700 l-h-36">
                {{ headerText }}
            </h2>
        </div>
        <div class="row w-100" style="margin-top: -48px; margin-bottom: -48px;">
            <div :class="columnClass" class="m-y-48" v-for="(item, index) in cardItems" :key="index">
                <div class="d-flex flex-column align-items-center p-x-8 p-x-small-0">
                    <img :src="$image(item.iconPath)" :alt="item.title" width="40px" height="40px" class="m-b-16">
                    <h4 class="m-b-4 font f-s-20 f-w-600 l-h-28 l-t-s-75 text-center">
                        {{ item.title }}
                    </h4>
                    <p class="m-0 font f-s-16 f-w-400 l-h-24 color-secondary text-center">
                        {{ item.caption }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        columnClass: {
            type: String,
            default: 'col-md-4',
        },
        titleText: {
            type: String,
            default: 'Consumer Insight for',
        },
        headerText: {
            type: String,
            default: 'Product Development',
        },
        cardItems: {
            type: Array,
            default: () => (
                [
                    {
                        iconPath: 'insights/Home.svg',
                        title: 'In-home Usage Testing',
                        caption: 'Gain insights into product performance and user experience through streamlined product testing with consumers in just a few clicks.',
                    },
                    {
                        iconPath: 'insights/Emoji.svg',
                        title: 'Sensory & Formula Testing',
                        caption: 'Perfect your product formula by conducting sensory and flavor tests from the early stages of development.',
                    },
                    {
                        iconPath: 'insights/Shipment.svg',
                        title: 'Packaging Testing',
                        caption: 'Refine your packaging strategy to enhance visibility, appeal, and functionality for your target audience.',
                    },
                    {
                        iconPath: 'insights/Expire.svg',
                        title: 'Efficacy & Claim Testing',
                        caption: 'Validate product claims and efficacy to build trust and credibility among consumers using a seamless process.',
                    },
                ]
            ),

        },

    },
};
</script>
